import React from 'react'
import HeaderSection from '../banner/HeaderSection'
import * as CONST from "../../../component/config/Constant";
import "../../../assets/css/form.css"
import { Link } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import PersonalInformation from './PersonalInformation';
import GuardianInformation from './GuardianInformation';
import EducationInformation from './EducationInformation';
import ChangePassword from './ChangePassword';
import Document from './Document';
import Experience from './Experience';
import Social from './Social';
import MyTestimonial from './MyTestimonial';
import { FiUser, FiLock, FiBookOpen, FiFileText, FiBriefcase, FiMessageSquare } from "react-icons/fi";
function MyProfile() {


	return (
		<>
			<HeaderSection
				title=""
				heading="Settings"
				addButton=""
				addLink=""
				addLinkName=""
				linktype=""
			/>
			<div className="page-body">
				<div className="container-xl">
					<div className="row row-cards">
						<div className="col-12">
							<div className="card">

								<div className="card-body">
									<Tab.Container id="left-tabs-example" defaultActiveKey="personal">
										<Row>
											<Col sm={3} className="acc-set-l-panel p-0">
												<div className='pb-2 pl-2' >
													<div className="page-pretitle"></div>
													<h5 className='page-title' >My Account</h5>
												</div>
												<Nav variant="pills" className="flex-column">
													<Nav.Item>
														<Nav.Link eventKey="personal"><FiUser size={16} className="mr-2" /> Personal Information</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="changePassword"><FiLock size={16} className="mr-2" /> Change Password</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="education"><FiBookOpen size={16} className="mr-2" /> Education</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="documents"><FiFileText size={16} className="mr-2" /> Documents</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="experience"><FiBriefcase size={16} className="mr-2" /> Experience</Nav.Link>
													</Nav.Item>
													<Nav.Item>
														<Nav.Link eventKey="testimonial"><FiMessageSquare size={16} className="mr-2" /> Testimonial</Nav.Link>
													</Nav.Item>
												</Nav>
											</Col>
											<Col sm={9}>
												<Tab.Content>
													<Tab.Pane eventKey="personal">
														<PersonalInformation />
													</Tab.Pane>
													<Tab.Pane eventKey="changePassword">
														<ChangePassword />
													</Tab.Pane>
													<Tab.Pane eventKey="guardian">
														<GuardianInformation />
													</Tab.Pane>
													<Tab.Pane eventKey="education">
														<EducationInformation />
													</Tab.Pane>
													<Tab.Pane eventKey="documents">
														<Document />
													</Tab.Pane>
													<Tab.Pane eventKey="experience">
														<Experience />
													</Tab.Pane>
													<Tab.Pane eventKey="social">
														<Social />
													</Tab.Pane>
													<Tab.Pane eventKey="testimonial">
														<MyTestimonial />
													</Tab.Pane>
												</Tab.Content>
											</Col>
										</Row>
									</Tab.Container>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</>
	)
}

export default MyProfile